import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { useGetUserProfileQuery } from '@Features/Dashboard/DashboardSlice/Dashboard.slice'
import { NumberFormatter } from '@Utilities/Formatters'
import { Icon as AbwIcon } from '@Components/AbwaabPlus'
import routes from '@Constants/Routes'

/**
 * The design's wallet balance chip (34px bordered pill on blue-08). Unlike the
 * old WalletAvatar it does not open the slide-in panel — it is a doorway to
 * the wallet page. Same profile query, same formatted balance.
 */
const WalletChip: React.FC = () => {
	const { isAuth } = useAppSelector(state => state.auth)
	const { data } = useGetUserProfileQuery(undefined, { skip: !isAuth })
	const navigate = useNavigate()
	const [t] = useTranslation(['wallet', 'generic'])

	if (!isAuth) return null
	const amount = data?.data.student.wallet.amount

	return (
		<Chip type="button" onClick={() => navigate(routes.activityWallet)} aria-label={t('wallet_button', { ns: 'activity_hub', defaultValue: 'المحفظة' })}>
			<AbwIcon name="credit-card" size={15} />
			<span>
				{amount !== undefined ? NumberFormatter(amount) : '—'} {t('egp', { ns: 'generic' })}
			</span>
		</Chip>
	)
}

export default WalletChip

const Chip = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	height: 34px;
	padding: 0 12px;
	border: 1px solid var(--border);
	border-radius: var(--r-full);
	background: var(--blue-08);
	color: var(--blue);
	font: var(--fw-bold) 12px var(--font-sans);
	font-family: var(--font-sans);
	cursor: pointer;
	white-space: nowrap;
	transition: background var(--dur-fast) var(--ease);
	&:hover {
		background: var(--blue-12);
	}
	@media (min-width: 1024px) {
		padding: 0 14px;
		font-size: 13px;
	}
`
